import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import Label from '../../../../../incase-domain/components/label/Label';
import DropdownMenuCompact from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import Button from '../../../../../incase-domain/components/button/Button';

interface FormElementPaddingBeforeProps {
    paddingBefore?: number;
    changePadding: (padding: number) => void;
}

function FormElementPaddingBefore(props: FormElementPaddingBeforeProps): ReactElement {
    const {paddingBefore, changePadding} = props;

    const {t} = useTranslation();

    const paddingValues = [
        {label: '0', value: '0'},
        {label: '1', value: '1'},
        {label: '2', value: '2'},
        {label: '3', value: '3'},
        {label: '4', value: '4'},
    ];

    return (
        <div className="l-group__item">
            <Label>{t('designSidepanel.paddingBefore')}</Label>
            <DropdownMenuCompact
                width="full"
                items={[paddingValues.map((el) => ({label: el.label, onClick: () => changePadding(Number(el.value))}))]}
            >
                <Button className="c-sidepanel__dropdown_button" variant="soft" trailing="solar:alt-arrow-down-linear" size="xs" fullWidth>
                    {paddingBefore || '0'}
                </Button>
            </DropdownMenuCompact>
        </div>
    );
}

export default FormElementPaddingBefore;
